import { styled } from '@linaria/react';
import { Flex, Menu, Stack } from '@mantine/core';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { baseWhite, skyDark, skyLightest } from '../../../../styles/design-tokens';
import { Button } from '../../../../ui-library/button/button';
import { Icon } from '../../../../ui-library/icon/icon';
import classes from '../../../../ui-library/select/select.module.css';
import { Text } from '../../../../ui-library/typography/typography';

interface MainSectionExportActionsProps {
  disabled: boolean;
  onExportCSV: () => void;
  onCreatePresentation: () => void;
  canExportPresentations: boolean;
}

export const MainSectionExportActions: FC<MainSectionExportActionsProps> = ({
  disabled,
  onExportCSV,
  onCreatePresentation,
  canExportPresentations,
}) => {
  const i18n = useTranslation();
  if (!canExportPresentations) {
    return (
      <Button
        variant="secondary"
        radius="xl"
        size="sm"
        leftSection={
          <Icon
            name="download"
            color={disabled ? skyDark : baseWhite}
            variant="filled"
            size={16}
            style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
          />
        }
        onClick={onExportCSV}
        disabled={disabled}
      >
        {i18n.t('common.actions.export')}
      </Button>
    );
  }

  return (
    <Menu shadow="md" width={220} position="bottom-end" offset={{ mainAxis: 2 }}>
      <Menu.Target>
        <Button
          variant="secondary"
          radius="xl"
          size="sm"
          leftSection={
            <Icon
              name="download"
              color={disabled ? skyDark : baseWhite}
              variant="filled"
              size={16}
              style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
            />
          }
          disabled={disabled}
        >
          {i18n.t('common.actions.export')}
        </Button>
      </Menu.Target>
      <Menu.Dropdown className={classes.dropdown} p={16}>
        <Stack gap={8}>
          <StyledMenuItem onClick={onExportCSV}>
            <Flex align="center" gap={8}>
              <Icon name="description" size={16} />
              <Text weight="medium">{i18n.t('strategy.initiatives.export_csv')}</Text>
            </Flex>
          </StyledMenuItem>
          <StyledMenuItem onClick={onCreatePresentation}>
            <Flex align="center" gap={8}>
              <Icon name="slideshow" size={16} />
              <Text weight="medium">{i18n.t('strategy.initiatives.create_presentation')}</Text>
            </Flex>
          </StyledMenuItem>
        </Stack>
      </Menu.Dropdown>
    </Menu>
  );
};

const StyledMenuItem = styled(Menu.Item)`
  border-radius: 16px;
  padding: 4px 16px;
  cursor: pointer;

  &:hover {
    background-color: ${skyLightest};
  }
`;
